import SchedulingModule from './containers/schedulingModule'

export {default as SchedulingModuleLayout} from './components/schedulingModuleLayout'

export default SchedulingModule
